import styled from '@emotion/styled'

import { PrismicRichText, RichTextBlock } from '@emico/prismic'

import {
    Category as PrismicCategory,
    CategoryBodySeoHeader,
} from './graphql/schema.generated'
import { getPrismicComponents } from './htmlSerializer'
import Container from './layout/Container'

const StyledContainer = styled(Container)`
    margin-bottom: 30px;
    text-align: center;
    padding: 0 20px;

    @media screen and (min-width: 768px) {
        padding: 0 40px;
    }

    @media screen and (min-width: 992px) {
        padding: 0 80px;
    }

    @media screen and (min-width: 1024px) {
        padding: 0 180px;
    }
`

interface HeaderProps {
    content: PrismicCategory | undefined
}

const PrismicCategorySeoHeader = ({ content }: HeaderProps) => {
    const CategoryBodySeoHeaderContent = content?.body?.find(
        (slice) => slice.__typename === 'CategoryBodySeoHeader',
    ) as CategoryBodySeoHeader | undefined

    const seoExtendedDescription =
        CategoryBodySeoHeaderContent?.primary?.seoExtendedContent

    if (!seoExtendedDescription) {
        return null
    }

    return (
        <StyledContainer>
            <PrismicRichText
                render={seoExtendedDescription as [RichTextBlock]}
                components={getPrismicComponents({})}
                analyticsContext="prismic.categorySeoHeader.content"
            />
        </StyledContainer>
    )
}

export default PrismicCategorySeoHeader
